import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetExpensesByEmployeesQuery } from "../../../services/Reports";
import {
  getExpensesByEmployeesRequest,
  getExpensesByEmployeesFailure,
  getExpensesByEmployeesSuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allExpensesByEmployees,
    isLoading: expensesByEmployeesLoading,
    isError: expensesByEmployeesError,
  } = useGetExpensesByEmployeesQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.expensesByEmployeesPageNo,
    pageSize: state.expensesByEmployeesPageSize,
    fromDate: new Date(state.expensesByEmployeesFromDate).toLocaleDateString(),
    toDate: new Date(state.expensesByEmployeesToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (expensesByEmployeesLoading) {
      dispatch(getExpensesByEmployeesRequest());
    }
    if (expensesByEmployeesError) {
      dispatch(getExpensesByEmployeesFailure(expensesByEmployeesError));
    }
    if (allExpensesByEmployees) {
      dispatch(
        getExpensesByEmployeesSuccess({
          data: allExpensesByEmployees.data.expensesByEmployee[0].data || [],
          totalPages:
            allExpensesByEmployees.data.expensesByEmployee[0].metadata[0]
              ?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allExpensesByEmployees,
    profileData,
    state.expensesByEmployeesFromDate,
    state.expensesByEmployeesToDate,
    state.expensesByEmployeesPageNo,
    state.expensesByEmployeesPageSize,
  ]);
  return <></>;
};
export default Content;
